export default __webpack_public_path__ + "static/Fellix-Bold-08a30514abd270e5436cd64948706db8.otf";